/**
 * Partner benefit configurations.
 * Add a new object here to spin up a new /partners/:slug landing page.
 * The <PartnerLanding /> component reads from this data source only —
 * every field below is data, not code.
 *
 * Fields:
 *  - slug: URL segment for /partners/:slug
 *  - name: Full partner name (used in headline, meta)
 *  - shortName: Optional shorter name for tight typography
 *  - logo:
 *      • text: renders a text-based wordmark if no image URL is supplied
 *      • image: URL to a hosted logo image (svg / png)
 *      • accent: brand accent color used by the text wordmark
 *  - intro: 2–3 sentence paragraph introducing Melbi as an employee benefit
 *  - categories: array of 3–4 treatment category strings
 *  - code: benefit code shown to employees
 *  - claimUrl: destination for the "Claim Your Benefit" CTA
 */
export const PARTNERS = {
  "franklin-street": {
    slug: "franklin-street",
    name: "Franklin Street",
    shortName: "Franklin Street",
    logo: {
      image: "/partners/franklin-street.png",
      alt: "Franklin Street",
    },
    intro:
      "As part of your Franklin Street employee benefits, Melbi Wellness is available to eligible team members at exclusive partner pricing. Melbi provides clinician-guided wellness care, delivered fully online with licensed U.S. pharmacy fulfillment. It is a modern benefit designed to support your team's energy, recovery, and long-term wellbeing.",
    categories: [
      "Weight Management Support (GLP-1s)",
      "Energy & Focus",
      "Vitality (NAD+)",
      "Recovery",
    ],
    code: "FRANKLINST",
    claimUrl: "https://www.melbiwellness.com",
  },
};

export function getPartner(slug) {
  return PARTNERS[slug];
}
